import React from 'react';
import PropTypes from 'prop-types';
import { userBooking as userBookingShape, customerInfo as customerInfoShape } from 'constants/propTypes';

import { Column } from 'components/shared/Layout';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import { BookingLink, BookingCancelled, StyledTableRow, StyledTableHeader, StyledTableCell } from '../ClubEurostarMember.styles';

const BookingsTable = ({ bookings, customerInfo }) => (
  <>
    {bookings.map((booking) => (
      <div key={booking.reference} style={{ margin: '20px 0' }}>
        <StyledTableRow columns={1}>
          <Column>
            <div style={{ display: 'flex' }}>
              <h3 data-cy="user-booking-reference">
                <BookingLink
                  // eslint-disable-next-line max-len
                  href={`/manage/bookings/${booking.reference}/journeys?membershipNumber=${customerInfo?.profile?.loyalty?.membershipNumber}`}
                  target="_blank"
                >
                  {booking.reference}
                </BookingLink>
              </h3>
              {booking.tickets.filter((t) => !t.isCancelled).length === 0 && (
                <BookingCancelled>
                  <FormattedMessage id="clubEurostar.ticketsCancelled" />
                </BookingCancelled>
              )}
            </div>
          </Column>
        </StyledTableRow>
        {booking.tickets.filter((t) => !t.isCancelled).length > 0 && (
          <StyledTableRow columns={5}>
            <StyledTableHeader span={1} justifyContent="center">
              <FormattedMessage id="searchBooking.departureDate" tagName="strong" />
            </StyledTableHeader>
            <StyledTableHeader span={1} justifyContent="center">
              <FormattedMessage id="segmentInfo.depart" tagName="strong" />
            </StyledTableHeader>
            <StyledTableHeader span={1} justifyContent="center">
              <FormattedMessage id="segmentInfo.arrive" tagName="strong" />
            </StyledTableHeader>
            <StyledTableHeader span={1} justifyContent="center">
              <FormattedMessage id="journeySummary.class" tagName="strong" />
            </StyledTableHeader>
            <StyledTableHeader span={1} justifyContent="center">
              <FormattedMessage id="clubEurostar.paxNo" tagName="strong" />
            </StyledTableHeader>
          </StyledTableRow>
        )}
        {booking.tickets
          .filter((t) => !t.isCancelled)
          .map((ticket) => (
            <StyledTableRow
              data-cy="user-booking-ticket"
              columns={5}
              key={`${booking.reference}-${ticket.departureDate}-${ticket.origin}-${ticket.destination}`}
            >
              <StyledTableCell span={1} justifyContent="center">
                {moment(ticket.departureDate, 'YYYY-MM-DD').format('Do MMMM YYYY')}
              </StyledTableCell>
              <StyledTableCell span={1} justifyContent="center">
                {ticket.origin}
              </StyledTableCell>
              <StyledTableCell span={1} justifyContent="center">
                {ticket.destination}
              </StyledTableCell>
              <StyledTableCell span={1} justifyContent="center">
                {ticket.serviceClassName}
              </StyledTableCell>
              <StyledTableCell span={1} justifyContent="center">
                {ticket.numberOfPassengers}
              </StyledTableCell>
            </StyledTableRow>
          ))}
      </div>
    ))}
  </>
);

BookingsTable.propTypes = {
  bookings: PropTypes.arrayOf(userBookingShape),
  customerInfo: customerInfoShape
};

export default BookingsTable;
